jQuery(function($) {
  /* navigation */
  $('.mobile-nav-toggle').on('click',function() {
    $('body').toggleClass('menu-open');
    $('.mobile-nav').addClass('menu-open');
    $('.mobile-nav').removeClass('menu-close');

    if ( $('body').hasClass('menu-open') ) {
      $('html > body').height($(window).height());
    } else {
      $('.mobile-nav').addClass('menu-close');
      $('.mobile-nav .sub-menu').removeClass('show');
    }
  })

  $('.mobile-nav li.menu-item-has-children > a').on('click', function(e) {
    $(this).parent().find('.sub-menu').addClass('show');
  })

  $('.mobile-nav li > a[href*="#"], .main-nav li a[href*="#"]').on('click', function(e) {
    e.preventDefault();
  })

  $('.mobile-nav > li.menu-item-has-children > .sub-menu').each(function() {
    var link = '<li><a href="#" class="back-to-main relative inline-block text-[16px] leading-[26px] hover:text-tertiary transition-colors uppercase pl-4 before:left-0 before:chevron before:bg-tertiary before:rotate-90 before:-translate-y-1/2">Back to Main Menu</a></li>';
    $(this).prepend(link);

    bindBackTo();
  })

  if ( $(window).width() < 768 ) {
    $('#accordion--lesson-list .tab-content .ld-expand-button').removeClass('ld-expanded')
  }

  $('.expand-video').on('click', function() {
    $('.learndash_post_sfwd-topic').toggleClass('expand-video-content');
    let width = $('.flowplayer').width();
    $('.flowplayer').width(width*2);
    $('.flowplayer').height('auto');
  })

  function bindBackTo() {
    $('.back-to-main').on('click', function(e) {
      e.preventDefault();
      $(this).parents('.sub-menu').removeClass('show');
    });
  }

  /* Newsletter */
  $('.newsletter-overlay').on('click', function() {
    close_newsletter();
  })

  $(".newsletter-close").on("click", function (e) {
    e.preventDefault();
    close_newsletter();
  })

  $(".newsletter-btn").on("click", function (e) {
    e.preventDefault();
    open_newsletter();
  })

  function open_newsletter() {
    $(".newsletter-drawer").addClass('open');
    $('body').addClass('overlay-open');
  }

  function close_newsletter() {
    $(".newsletter-drawer").removeClass('open');
    $('body').removeClass('overlay-open');
  }

  // Hash Scroll
  $('a[href*="#"]').not('.newsletter-btn').not('.external-link').not('.pagination a').not('.mobile-nav a')
  .not('.main-nav a').not('#menu-utility-menu a').not('.not-hash-scroll').on('click', function(e) {
    e.preventDefault();
    var target = $(this.hash);
    var scroll = target.offset().top;
    var currentPos = $(window).scrollTop();
    var direction;

    if ( currentPos < scroll ) {
      direction = 'down';
    } else {
      direction = 'up';
    }
    //console.log(currentPos)
    //console.log(scroll)

    if ( $('.site-header').length > 0 && direction == 'up' )
      scroll = scroll - parseInt($('.site-header').outerHeight());

    if ( $('#wpadminbar').length > 0 )
      scroll = scroll - parseInt($('#wpadminbar').outerHeight());

    if ( $(this).data('offset') && $(this).data('offset') != undefined )
      scroll = scroll - $(this).data('offset');

    $('html, body').animate({
      scrollTop: scroll
    }, 800);
  });

  // TOC toggle
  $('.toc-sidebar .sidebar-header').on('click', function() {
    $('.toc-sidebar').toggleClass('show');
  })
})

// header scroll animation
var scroll_pos = 0;
var last_scroll_pos = 0;
var ticking = false;
var down_scroll_pos_trigger = 130;
var up_scroll_pos_trigger = 75;

const fade_observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view')
      observer.unobserve(entry.target)
    }
  })
}, {
  threshold: .1
})

const fade_in_content = document.querySelectorAll('.kp-fade-in-animation');
fade_in_content.forEach(block => {
  fade_observer.observe(block)
})


const bodyEl = document.querySelector('body')
const downThreshold = 140
function animateMenu(scroll_pos, direction) {
  if (direction === 'down' && scroll_pos >= downThreshold && !bodyEl.classList.contains('hide-menu')) {
    bodyEl.classList.add('hide-menu')
  }
  if (direction === 'up' && bodyEl.classList.contains('hide-menu')) {
    bodyEl.classList.remove('hide-menu')
  }
}

window.addEventListener( 'scroll', handleScroll, {passive: true} );

function handleScroll() {
  scroll_pos = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function() {
      let direction = getDirection(scroll_pos, last_scroll_pos);

      animateMenu(scroll_pos, direction)

      ticking = false;
      last_scroll_pos = scroll_pos;
    });

    ticking = true;
  }
}

function getDirection(scroll_pos, last_scroll_pos) {
  if ( scroll_pos > last_scroll_pos ) {
    return 'down';
  } else if ( scroll_pos < last_scroll_pos ) {
    return 'up';
  }
}


// Datalayer Pushes


// window.addEventListener('load', function() {
//   let accordion_items = document.querySelectorAll('.block--accordion .tab');
//   if ( accordion_items.length > 0 ) {
//     for ( i=0; i<accordion_items.length; i++ ) {
//       let item = accordion_items[i]
//       item.querySelector('input').addEventListener('click', function(e) {
//         window.dataLayer.push({
//           'event': 'accordion',
//           'accordion_item': this.parentNode.querySelector('h3').innerText
//         })
//       })
//     }
//   }
//
// })